<form [formGroup]="loginForm" (ngSubmit)="login()" aria-labelledby="title">
  <div class="d-flex flex-column gap-2">
    <div class="input-group">
      <div class="form-floating">
        <input
          class="form-control"
          type="email"
          [class.is-invalid]="
            loginForm.controls['username'].invalid &&
            loginForm.controls['username'].touched
          "
          formControlName="username"
          id="username"
          placeholder="Username"
          pattern=".+@.+\..+"
          autocorrect="off"
          autocapitalize="off"
          (input)="checkIfEmailChanged()"
        />
        <label for="username">Email Address</label>
      </div>
      @if (loginForm.value?.username) {
        <span
          class="input-group-text"
          (click)="loginForm.reset(); checkIfEmailChanged()"
        >
          <i class="fa-solid fa-xmark md-font-size"></i>
        </span>
      }
    </div>

    @if (loginForm.controls["username"].hasError("alreadyExists")) {
      <div class="text-danger small">You have already added this account.</div>
    }
    @if (
      loginForm.controls["username"].invalid &&
      loginForm.controls["username"].touched
    ) {
      <div class="text-danger small">Invalid email address</div>
    }

    @if (showForm === "userNameForm") {
      <div>
        <button
          class="btn btn-lg btn-primary w-100"
          type="submit"
          [disabled]="!loginForm.valid"
        >
          Next
        </button>
      </div>
    }
    <!-- If entered email is in db and this is the first time login of that email -->
    @if (showForm === "vCodeForm") {
      <div>
        <div class="form-floating">
          <input
            class="form-control"
            type="tel"
            inputmode="numeric"
            pattern="[0-9]*"
            [class.is-invalid]="
              loginForm.controls['auth_code'].invalid &&
              loginForm.controls['auth_code'].touched
            "
            formControlName="auth_code"
            id="verCode"
            placeholder="Verification Code"
            [maxlength]="6"
            autofocus
            autocomplete="off"
            (input)="loginForm.valid ? login() : null"
          />
          <label for="verCode">Verification Code</label>
          @if (
            loginForm.controls["auth_code"].invalid &&
            loginForm.controls["auth_code"].touched
          ) {
            <div class="invalid-feedback">Verification code is required!</div>
          }
        </div>

        <div class="mt-3">
          <button
            class="btn btn-lg btn-primary w-100"
            [disabled]="!loginForm.valid"
          >
            Verify
          </button>
        </div>

        <div class="mt-3 ms-2 small">
          By signing in you agree to our
          <span>
            <a
              class="terms-link pointer"
              href="https://guardtracker.com.au/terms"
              target="_blank"
              >Terms of Service</a
            >
            and
            <a
              class="terms-link pointer"
              href="https://guardtracker.com.au/privacy"
              target="_blank"
              >Privacy Policy</a
            >
          </span>
        </div>
      </div>
    }
    @if (showForm === "passwordForm" && !isPasswordAlreadyset) {
      <div class="mt-3">
        <button
          class="btn btn-lg btn-primary w-100"
          type="button"
          (click)="sendVCode('oneTime')"
        >
          Get One Time Pin
        </button>
      </div>
    }
    <!-- If entered email is in db and user has logged in at least once -->
    @if (
      (showForm === "passwordForm" && isPasswordAlreadyset) ||
      showForm === "dummyPasswordForm"
    ) {
      <div>
        <div class="input-group">
          <div class="form-floating">
            <input
              id="passwordInputField"
              class="form-control"
              [type]="showPassword ? 'text' : 'password'"
              [class.is-invalid]="
                loginForm.controls['password'].invalid &&
                loginForm.controls['password'].touched
              "
              formControlName="password"
              id="inputPassword"
              placeholder="Password"
              [minlength]="8"
            />
            <label for="inputPassword">Password</label>
          </div>
          @if (showPassword === true) {
            <span class="input-group-text" (click)="showPassword = false">
              <i class="fa-regular fa-eye"></i>
            </span>
          }
          @if (showPassword === false) {
            <span class="input-group-text" (click)="showPassword = true">
              <i class="fa-regular fa-eye-slash"></i>
            </span>
          }
        </div>
        @if (
          loginForm.controls["password"].invalid &&
          loginForm.controls["password"].touched
        ) {
          <div class="text-danger small">Password is required!</div>
        }

        @if (showForm === "dummyPasswordForm") {
          <div class="mt-3">
            <!-- No need to show forgot otp and webauthn option as the email is not in our db -->
            <button
              class="btn btn-lg btn-primary w-100"
              [disabled]="!loginForm.valid"
            >
              Sign In
            </button>
          </div>
        }
        @if (isPasswordAlreadyset && showForm === "passwordForm") {
          <div class="mt-3">
            <!-- Case when the email address is in the db and the user has logged in at least once -->
            <div
              [ngClass]="
                fidoRegistered && !hideSignInLInkForgotPasswordBtn
                  ? 'row row-cols-2'
                  : 'row row-cols-1'
              "
            >
              <div class="col mb-2">
                <button
                  class="btn btn-lg btn-primary w-100"
                  [disabled]="!loginForm.valid"
                >
                  Sign In
                </button>
              </div>
              @if (fidoRegistered && !hideSignInLInkForgotPasswordBtn) {
                <div class="col mb-2">
                  <button
                    class="btn btn-lg btn-success w-100"
                    type="button"
                    (click)="authenticate()"
                  >
                    Sign In with Passkey
                  </button>
                </div>
              }
            </div>
            @if (!hideSignInLInkForgotPasswordBtn) {
              <div>
                <button
                  class="btn btn-lg btn-link text-dark-emphasis w-100 border border-1 border-dark-subtle"
                  type="button"
                  (click)="sendVCode()"
                >
                  Forgot Password
                </button>
              </div>
            }

            <!-- Agreement -->
            <div class="ms-2 small mt-4">
              By signing in you agree to our
              <span>
                <a
                  class="terms-link pointer"
                  href="https://guardtracker.com.au/terms"
                  target="_blank"
                  >Terms of Service</a
                >
                and
                <a
                  class="terms-link pointer"
                  href="https://guardtracker.com.au/privacy"
                  target="_blank"
                  >Privacy Policy</a
                >
              </span>
            </div>
          </div>
        }
      </div>
    }
  </div>
</form>
